import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import "./LearningPathPage.css";
import Footer from "../components/Footer";


const baseUrl = process.env.REACT_APP_API_BASE_URL;

const formatLabel = (label) =>
  label
    .split("-")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");

const LearningPathPage = ({ pathId, problems, expandedGroups }) => {
  const navigate = useNavigate();
  // const [problems, setProblems] = useState([]);
  // const [loading, setLoading] = useState(true);

  const groupByDifficulty = (problems) => {
    return {
      EASY: problems.filter((p) => p.difficulty === "EASY"),
      MEDIUM: problems.filter((p) => p.difficulty === "MEDIUM"),
      HARD: problems.filter((p) => p.difficulty === "HARD"),
    };
  };

  const difficulties = groupByDifficulty(problems);

  return (
    <div className="path-container">
      <h1 className="path-title">{formatLabel(pathId)} Path</h1>
      {problems.length === 0 ? (
        <p>No problems found.</p>
      ) : (
        <div className="path-list">
          {["EASY", "MEDIUM", "HARD"].map((level) =>
            difficulties[level].length > 0 ? (
              <div key={level} className="difficulty-column">
                <h2 className={`difficulty-heading ${level.toLowerCase()}`}>
                  {level[0] + level.slice(1).toLowerCase()} Level
                </h2>
                <ul className="path-page problem-list">
                  {difficulties[level].map((problem, i) => {
                    const { BEGINNER, PRO } = problem.progress || {};
                    const completeClass =
                      BEGINNER && PRO
                        ? "both-complete"
                        : BEGINNER
                          ? "block-complete"
                          : PRO
                            ? "code-complete"
                            : "";

                    return (
                      <li
                        key={problem.id}
                        className={`path-page problem-list-item ${level.toLowerCase()} ${completeClass}`}
                        onClick={() => navigate(`/problems/${problem.id}`)}
                      >
                        <div className="path-page problem-title-row">
                          <span className="path-page problem-index">{i + 1}.</span>
                          <span className="path-page problem-title">{problem.title}</span>
                        </div>
                        <div className="path-page completion-labels">
                          <button
                            className={`path-page mode-button ${BEGINNER ? "path-page complete" : "path-page incomplete"}`}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent triggering the parent onClick
                              navigate(`/problems/${problem.id}`, {
                                state: {
                                  level: "BEGINNER",
                                  mode: "blocks",
                                  progress: problem.progress,
                                  fromLearningPath: true,
                                  learningPath: pathId,
                                  expandedGroups,
                                },
                              });
                            }}
                          >
                            Blocks {BEGINNER ? "✅" : "⬜"}
                          </button>
                          <button
                            className={`mode-button ${PRO ? "path-page complete" : "path-page incomplete"}`}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent triggering the parent onClick
                              navigate(`/problems/${problem.id}`, {
                                state: {
                                  level: "PRO",
                                  mode: "code",
                                  progress: problem.progress,
                                  fromLearningPath: true,
                                  learningPath: pathId,
                                  expandedGroups,
                                },
                              });
                            }}
                          >
                            Code {PRO ? "✅" : "⬜"}
                          </button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null
          )}
          
        </div>
      )}
      
    </div>
  );
};

export default LearningPathPage;
